// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".markdown {\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n  font-size: 13px;\n  line-height: 1.1em;\n}\n.markdown p {\n  margin: 0;\n}\n.markdown p + p {\n  margin-top: 10px;\n}\n.markdown ul,\n.markdown ol {\n  padding-left: 20px;\n  margin: 0px;\n}\n.markdown h2 {\n  margin: 10px 0;\n}\n", ""]);
// Exports
module.exports = exports;
